/**
 * Vincolo di query per la visibilita' backoffice (PR-BO).
 *
 * Le Firestore Rules non filtrano: se una query puo' restituire anche un
 * solo documento non leggibile, l'INTERA query viene rifiutata. Quindi
 * ogni query di un client non-backoffice su `appuntamenti` deve portare
 * `where('soloBackoffice','==',false)` — anche quando il filtro non
 * potrebbe mai matchare un documento nascosto (es. `stato == 'programmato'`):
 * le Rules pretendono il vincolo, non il suo effetto.
 *
 * Gli operatori di backoffice sono un caso diverso: sono nascosti SEMPRE,
 * anche a un utente di backoffice, quindi su `/operatori` e `/users` il
 * vincolo non e' condizionale (vedi `vincoloOperatoriVisibili`).
 */

import { where, type QueryConstraint } from 'firebase/firestore';

/** Nome del campo denormalizzato, unico punto in cui compare come stringa. */
export const CAMPO_SOLO_BACKOFFICE = 'soloBackoffice';

/**
 * Vincolo per le query su `appuntamenti`. Vuoto per gli account di
 * backoffice, che vedono tutto.
 */
export function vincoloVisibilitaAppuntamenti(
  isBackoffice: boolean
): QueryConstraint[] {
  return isBackoffice ? [] : [where(CAMPO_SOLO_BACKOFFICE, '==', false)];
}

/**
 * Vincolo per le query su `pazienti`: stessa forma, campo derivato
 * dall'ultima visita completata invece che dal singolo documento.
 *
 * Vale per OGNI `list` sulla collezione, ricerca a prefisso e lettura a
 * lotti per id comprese. La lettura di un singolo paziente non lo porta:
 * li' e' la Rule `get` a decidere, e il client deve saper gestire un
 * `permission-denied`.
 */
export function vincoloVisibilitaPazienti(
  isBackoffice: boolean
): QueryConstraint[] {
  return isBackoffice ? [] : [where(CAMPO_SOLO_BACKOFFICE, '==', false)];
}

/**
 * Vincolo per le liste di operatori (`/operatori` e `/users`): sempre
 * attivo, indipendentemente da chi guarda.
 */
export function vincoloOperatoriVisibili(): QueryConstraint[] {
  return [where(CAMPO_SOLO_BACKOFFICE, '==', false)];
}
